export const widgets = {
  zohoCrm: {
    settings: {
      welcomeToBotPenguin: '欢迎使用BotPenguin！',
      login: '登录',
      youAreAllSet: '您已经准备好了！您可以从线索详情页面使用WhatsApp收件箱。',
      placeholders: {
        enterEmail: '输入电子邮件',
        enterPassword: '输入密码'
      }
    }
  }
};
